<template>
  <i18n-t :keypath="'NotificationsComponent.' + notification.type" tag="span" class="pl-quarter" scope="global">
    <template #link>
      <router-link v-if="!notification.params?.linkToOutsideSite" :to="{ name: notification.params?.url }">
        {{ t(notificationMessage) }}
      </router-link>
      <button v-else class="inline-btn-link" type="button" @click="goToUrl()">{{ t(notificationMessage) }}</button>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from "vue";
import { t } from "@/i18n";
import { INotification, INotificationParams } from "@/stores/notifications";

const componentName = "LoginFailedNotification";

export default defineComponent({
  name: componentName,
  props: {
    notification: {
      type: Object as PropType<INotification>,
      default: null,
    },
  },
  setup(props) {
    const notificationMessage = ref<string>((props.notification?.params as INotificationParams)?.text ?? "");

    function goToUrl() {
      if (props.notification?.params && props.notification?.params?.url)
        window.location.href = props.notification.params.url;
    }

    return { t, notificationMessage, goToUrl };
  },
});
</script>
